import * as types from '../actions/PlanOrderActionTypes';
import * as agentTypes from '../agent/ActionTypes';
import * as Status from '../PlanOrderStatus';
import * as OrderActionTypes from '../../ActionTypes';
import InitialState from './InitialState';
import { assign } from '../../../../../shared/Assign';
import {
    IMPERSONATE_SUCCESS,
    UNIMPERSONATE_SUCCESS,
    LOGOUT_SUCCESS
} from '../../../../../actions/actionTypes';
import {
    ExternalAnnotation,
    DeliveryAnnotation,
    ExternalDeliveryAnnotation
} from '../../../../planannotation/AnnotationTypes';
import { UPDATE_ORDER_ROW_SUCCESS } from '../../basicorderinfo/ActionTypes';

export default function planOrderReducer(
    state: any = InitialState.viewPlanOrder,
    action: { type: string; result: any }
) {
    let newState: any;

    switch (action.type) {
        case types.GET_PLAN_ORDER_SUCCESS:
            return {
                ...state,
                planOrder: action.result.new ? action.result.new.planOrder : null,
                availableStories: action.result.new
                    ? action.result.new.stories
                    : state.availableStories,
                deliveredPlanOrder: action.result.delivered ? action.result.delivered : null,
                isInProgress: !action.result.delivered
                    ? action.result.isInProgress
                    : state.isInProgress
            };
        case types.SEND_PLAN_ORDER_SUCCESS:
            newState = assign({}, state);
            newState.isInProgress = true;
            return newState;
        case types.ADMIN_SEND_PLAN_ORDER_SUCCESS:
            newState = assign({}, state);
            newState.planOrder.sketchUpStatus = action.result.sketchUpStatus;
            newState.planOrder.roomSketcherStatus = action.result.roomSketcherStatus;
            newState.planOrder.startDate = action.result.startDate;
            return newState;
        case types.GET_ADMIN_PLAN_ORDER_SUCCESS:
            newState = assign({}, state);
            newState.planOrder = action.result.planOrder;
            newState.isMeasured = action.result.measured;
            newState.products = action.result.products;
            newState.planUserFirms = action.result.planUserFirms;
            newState.planEditors = action.result.planEditors;

            return newState;
        case types.GET_ADMIN_PLAN_COMPARE_DATA_SUCCESS:
            newState = assign({}, state);
            newState.compareStoreys = action.result;

            return newState;
        case types.ADD_STOREY_SUCCESS:
            newState = assign({}, state);
            newState.planOrder.stories = newState.planOrder.stories.concat(
                action.result.stories.map((x) => {
                    x.files = [];
                    if (x.files.id) {
                        x.files.push({
                            id: x.file.id,
                            planOrderStoreyId: x.id,
                            warmStorageReference: x.file.fileReference,
                            filename: x.file.filename,
                            revisions: [],
                            isBlueprint: true,
                            rolename: 'role/administrator'
                        });
                    }

                    return assign({}, x);
                })
            );

            if (newState.planOrder.orderRows) {
                newState.planOrder.orderRows = newState.planOrder.orderRows.concat(
                    action.result.orderRows.map((x) => assign({}, x))
                );
            }
            return newState;
        case types.DELETE_STOREY_SUCCESS:
            newState = assign({}, state);
            newState.planOrder.stories = [
                ...newState.planOrder.stories.filter((x: any) => x.id !== action.result.storeyId)
            ];

            if (action.result.orderRowId && newState.planOrder.orderRows) {
                newState.planOrder.orderRows = [
                    ...newState.planOrder.orderRows.filter(
                        (x: any) => x.id !== action.result.orderRowId
                    )
                ];
            }

            if (newState.planOrder.delivery) {
                newState.planOrder.delivery = assign({}, action.result.deliveryFiles);
            }

            return newState;
        case types.EDIT_EXTERNAL_FILE_ANNOTATION_SUCCESS:
        case types.EDIT_PLAN_ANNOTATION_SUCCESS:
            newState = assign({}, state);
            newState.annotation = assign({}, action.result);
            return newState;
        case types.UPDATE_PLAN_ORDER_SUCCESS:
            newState = assign({}, state);
            let planOrder = newState.planOrder;
            let value = action.result.storeyId;
            let label = action.result.customStoreyName;
            let storeyIndex = newState.planOrder.stories.findIndex(
                (x) => x.id === action.result.id
            );

            if (value === -1 && label !== null) {
                let availableStories: any[] = planOrder.stories[storeyIndex].availableStories;
                if (availableStories[0].id === value) {
                    availableStories[0].name = label;
                } else {
                    availableStories.unshift({ id: value, name: label });
                }
            }

            planOrder.stories[storeyIndex].storeyId = value;
            planOrder.stories[storeyIndex].customStoreyName = label;
            planOrder.stories[storeyIndex].storeyName = action.result.storeyName;
            return newState;
        case types.UPDATE_PLAN_ORDER_STOREY_SORT_SUCCESS:
            newState = assign({}, state);
            let stories: any[] = newState.planOrder.stories;
            action.result.forEach((item) => {
                let match = stories.find((x) => x.id === item.id);
                if (match) {
                    match.sort = item.sort;
                }
            });
            newState.stories = [...stories.sort((a, b) => a.sort - b.sort)];
            return newState;
        case types.SAVE_PLAN_ANNOTATION_SUCCESS:
            newState = assign({}, state);

            if (action.result) {
                let id = action.result.id;

                if (action.result.annotationType === ExternalAnnotation) {
                    let file = newState.deliveredPlanOrder
                        ? newState.deliveredPlanOrder.deliveryFiles.externalAnnotationFiles.find(
                              (f) =>
                                  f.planOrderExternalFileId === action.result.parentId ||
                                  f.planOrderExternalFileId === action.result.grandparentId
                          )
                        : newState.planOrder.delivery.externalAnnotationFiles.find(
                              (f) =>
                                  f.planOrderExternalFileId === action.result.parentId ||
                                  f.planOrderExternalFileId === action.result.grandparentId
                          );
                    if (file) {
                        file.planOrderExternalFileId = id;
                        file.fileReference = action.result.fileReference;
                        file.thumbnailReference = action.result.thumbnailReference;
                        file.filename = action.result.filename;
                    } else if (newState.deliveredPlanOrder) {
                        newState.deliveredPlanOrder.deliveryFiles.externalAnnotationFiles.push({
                            planOrderExternalFileId: id,
                            fileReference: action.result.fileReference,
                            thumbnailReference: action.result.thumbnailReference,
                            fileType: action.result.fileType,
                            filename: action.result.filename
                        });
                    } else {
                        newState.planOrder.delivery.externalAnnotationFiles.push({
                            planOrderExternalFileId: id,
                            fileReference: action.result.fileReference,
                            thumbnailReference: action.result.thumbnailReference,
                            fileType: action.result.fileType,
                            filename: action.result.filename
                        });
                    }

                    return newState;
                } else if (action.result.annotationType === ExternalDeliveryAnnotation) {
                    let file = newState.deliveredPlanOrder
                        ? newState.deliveredPlanOrder.deliveryFiles.externalDeliveryFiles.find(
                              (f) => f.planOrderExternalFileId === action.result.parentId
                          )
                        : newState.planOrder.delivery.externalDeliveryFiles.find(
                              (f) => f.planOrderExternalFileId === action.result.parentId
                          );
                    if (file) {
                        file.planOrderExternalFileId = id;
                        file.fileReference = action.result.fileReference;
                        file.thumbnailReference = action.result.thumbnailReference;
                        file.filename = action.result.filename;
                    }

                    return newState;
                } else if (action.result.annotationType === DeliveryAnnotation) {
                    let storeys: any[] = [];
                    if (newState.deliveredPlanOrder) {
                        storeys = newState.deliveredPlanOrder.deliveryFiles.stories;
                    } else {
                        storeys = newState.planOrder.delivery.stories;
                    }

                    storeys.forEach((storey) => {
                        let matchFiles = (files: any[], id: number): any => {
                            let result: any = null;
                            files.forEach((file) => {
                                if (file.deliveryFileId === id) {
                                    result = file;
                                }
                            });

                            return result;
                        };

                        let subject: any = null;
                        if (storey.sketchUpPlan2Ds) {
                            subject = matchFiles(storey.sketchUpPlan2Ds, action.result.parentId);
                        }

                        if (!subject && storey.sketchUpPlan3Ds) {
                            subject = matchFiles(storey.sketchUpPlan2Ds, action.result.parentId);
                        }

                        if (!subject && storey.roomSketcherPlan2Ds) {
                            subject = matchFiles(
                                storey.roomSketcherPlan2Ds,
                                action.result.parentId
                            );
                        }

                        if (!subject && storey.roomSketcherPlan3Ds) {
                            subject = matchFiles(
                                storey.roomSketcherPlan3Ds,
                                action.result.parentId
                            );
                        }

                        if (subject) {
                            subject.deliveryFileId = action.result.id;
                            subject.fileReference = action.result.fileReference;
                            subject.thumbnailReference = action.result.thumbnailReference;
                            subject.filename = action.result.filename;
                        }
                    });
                }

                if (newState.planOrder) {
                    newState.planOrder.stories.forEach((storey) => {
                        if (!storey.files) {
                            storey.files = [];
                        }

                        if (storey.file && storey.file.id === id) {
                            if (!storey.blueprint) {
                                storey.blueprint = {
                                    id: storey.file.id,
                                    fileReference: storey.file.fileReference,
                                    thumbnailReference: storey.file.thumbnailReference,
                                    filename: storey.file.filename
                                };
                            }

                            if (!storey.originalBlueprint) {
                                storey.originalBlueprint = {
                                    filename: storey.file.filename,
                                    fileReference: storey.file.fileReference
                                };
                            }

                            if (action.result.original) {
                                storey.file.id = action.result.original.id;

                                storey.files.push({
                                    id: action.result.original.id,
                                    planOrderStoreyId: storey.id,
                                    warmStorageReference: action.result.fileReference,
                                    filename: storey.file.filename,
                                    isBlueprint: true,
                                    revisions: [],
                                    rolename: 'role/administrator',
                                    parentId: id
                                });
                            }

                            storey.file.fileReference = action.result.fileReference;
                            storey.file.thumbnailReference = action.result.thumbnailReference;
                            storey.file.createdByAdmin = true;
                            storey.file.isAnnotation = action.result.isAnnotation;

                            if (storey.files) {
                                let file = storey.files.find((x) => x.id === id);

                                if (file) {
                                    file.revisions.push({
                                        warmStorageReference: action.result.fileReference,
                                        filename: storey.file.filename,
                                        rolename: 'role/administrator'
                                    });
                                }
                            }
                        } else if (storey.file2D && storey.file2D.id === id) {
                            if (action.result.original) {
                                storey.file2D.id = action.result.original.id;

                                storey.files.push({
                                    id: action.result.original.id,
                                    planOrderStoreyId: storey.id,
                                    warmStorageReference: action.result.fileReference,
                                    filename: storey.file2D.filename,
                                    is2D: true,
                                    revisions: [],
                                    rolename: 'role/administrator',
                                    parentId: id
                                });
                            }

                            storey.file2D.fileReference = action.result.fileReference;
                            storey.file2D.thumbnailReference = action.result.thumbnailReference;
                            storey.file2D.isAnnotation = action.result.isAnnotation;

                            let file = storey.files.find((x) => x.id === id);
                            if (file) {
                                file.revisions.push({
                                    warmStorageReference: action.result.fileReference,
                                    filename: storey.file2D.filename,
                                    rolename: 'role/administrator'
                                });
                            }
                        } else if (storey.file3D && storey.file3D.id === id) {
                            if (action.result.original) {
                                storey.file3D.id = action.result.original.id;

                                storey.files.push({
                                    id: action.result.original.id,
                                    planOrderStoreyId: storey.id,
                                    warmStorageReference: action.result.fileReference,
                                    filename: storey.file3D.filename,
                                    is3D: true,
                                    revisions: [],
                                    rolename: 'role/administrator',
                                    parentId: id
                                });
                            }

                            storey.file3D.fileReference = action.result.fileReference;
                            storey.file3D.thumbnailReference = action.result.thumbnailReference;
                            storey.file3D.isAnnotation = action.result.isAnnotation;

                            let file = storey.files.find((x) => x.id === id);

                            if (file) {
                                file.revisions.push({
                                    warmStorageReference: action.result.fileReference,
                                    filename: storey.file3D.filename,
                                    rolename: 'role/administrator'
                                });
                            }
                        } else if (
                            storey.roomSketcherFile2D &&
                            storey.roomSketcherFile2D.id === id
                        ) {
                            if (action.result.original) {
                                storey.roomSketcherFile2D.id = action.result.original.id;

                                storey.files.push({
                                    id: action.result.original.id,
                                    planOrderStoreyId: storey.id,
                                    warmStorageReference: action.result.fileReference,
                                    filename: storey.roomSketcherFile2D.filename,
                                    is2D: true,
                                    revisions: [],
                                    rolename: 'role/administrator',
                                    parentId: id
                                });
                            }

                            storey.roomSketcherFile2D.fileReference = action.result.fileReference;
                            storey.roomSketcherFile2D.thumbnailReference =
                                action.result.thumbnailReference;
                            storey.roomSketcherFile2D.isAnnotation = action.result.isAnnotation;

                            let file = storey.files.find((x) => x.id === id);

                            if (file) {
                                file.revisions.push({
                                    warmStorageReference: action.result.fileReference,
                                    filename: storey.roomSketcherFile2D.filename,
                                    rolename: 'role/administrator'
                                });
                            }
                        } else if (
                            storey.roomSketcherFile3D &&
                            storey.roomSketcherFile3D.id === id
                        ) {
                            if (action.result.original) {
                                storey.roomSketcherFile3D.id = action.result.original.id;

                                storey.files.push({
                                    id: action.result.original.id,
                                    planOrderStoreyId: storey.id,
                                    warmStorageReference: action.result.fileReference,
                                    filename: storey.roomSketcherFile3D.filename,
                                    is3D: true,
                                    revisions: [],
                                    rolename: 'role/administrator',
                                    parentId: id
                                });
                            }

                            storey.roomSketcherFile3D.fileReference = action.result.fileReference;
                            storey.roomSketcherFile3D.thumbnailReference =
                                action.result.thumbnailReference;
                            storey.roomSketcherFile3D.isAnnotation = action.result.isAnnotation;

                            let file = storey.files.find((x) => x.id === id);

                            if (file) {
                                file.revisions.push({
                                    warmStorageReference: action.result.fileReference,
                                    filename: storey.roomSketcherFile3D.filename,
                                    rolename: 'role/administrator'
                                });
                            }
                        }
                    });
                } else if (newState.deliveredPlanOrder) {
                    newState.deliveredPlanOrder.deliveryFiles.stories.forEach((s) => {
                        if (
                            s.sketchUpPlan2Ds &&
                            s.sketchUpPlan2Ds.length > 0 &&
                            s.sketchUpPlan2Ds[0].id === id
                        ) {
                            s.sketchUpPlan2Ds.forEach((sketchUpPlan2D) => {
                                sketchUpPlan2D.reference = action.result.fileReference;
                                sketchUpPlan2D.thumbnailReference =
                                    action.result.thumbnailReference;
                            });
                        } else if (
                            s.sketchUpPlan3Ds &&
                            s.sketchUpPlan3Ds.length > 0 &&
                            s.sketchUpPlan3Ds[0].id === id
                        ) {
                            s.sketchUpPlan3Ds.forEach((sketchUpPlan3D) => {
                                sketchUpPlan3D.reference = action.result.fileReference;
                                sketchUpPlan3D.thumbnailReference =
                                    action.result.thumbnailReference;
                            });
                        } else if (
                            s.roomSketcherPlan2Ds &&
                            s.roomSketcherPlan2Ds.length > 0 &&
                            s.roomSketcherPlan2Ds[0].id === id
                        ) {
                            s.roomSketcherPlan2Ds.forEach((roomSketcherPlan2D) => {
                                roomSketcherPlan2D.reference = action.result.fileReference;
                                roomSketcherPlan2D.thumbnailReference =
                                    action.result.thumbnailReference;
                            });
                        } else if (
                            s.roomSketcherPlan3Ds &&
                            s.roomSketcherPlan3Ds.length > 0 &&
                            s.roomSketcherPlan3Ds[0].id === id
                        ) {
                            s.roomSketcherPlan3Ds.forEach((roomSketcherPlan3D) => {
                                roomSketcherPlan3D.reference = action.result.fileReference;
                                roomSketcherPlan3D.thumbnailReference =
                                    action.result.thumbnailReference;
                            });
                        }
                    });
                }
            }

            return newState;
        case types.UPDATE_PLAN_FIRM_SUCCESS:
            newState = assign({}, state);
            newState.planOrder.planFirmId = action.result;
            return newState;
        case types.UPDATE_PLAN_EDITOR_SUCCESS:
            newState = assign({}, state);
            newState.planOrder.planEditorId = action.result.planEditorId;
            return newState;
        case types.REMOVE_PLAN_ORDER_ROW_SUCCESS:
            newState = assign({}, state);
            newState.planOrder.orderRows = [
                ...newState.planOrder.orderRows.filter((x) => x.id !== action.result)
            ];
            return newState;
        case types.ADD_ORDER_ROW_SUCCESS:
            newState = assign({}, state);
            if (action.result.sketchUpStatus) {
                newState.planOrder.sketchUpStatus = action.result.sketchUpStatus;
            }

            if (action.result.roomSketcherStatus) {
                newState.planOrder.roomSketcherStatus = action.result.roomSketcherStatus;
            }

            newState.planOrder.orderRows = [
                ...newState.planOrder.orderRows,
                assign({}, action.result.orderRow)
            ];
            return newState;

        case UPDATE_ORDER_ROW_SUCCESS:
            newState = assign({}, state);
            let newOrderRow = assign({}, action.result.orderRow);
            let orderRowModel = {
                id: newOrderRow.id,
                name: newOrderRow.productName,
                productId: newOrderRow.productId,
                quantity: newOrderRow.quantity,
                canChange: newOrderRow.canChange,
                canRemove: newOrderRow.canRemove
            };
            if (newState.planOrder && newState.planOrder.orderRows) {
                newState.planOrder.orderRows = [
                    ...state.planOrder.orderRows.filter(
                        (x: any) => x.id !== action.result.orderRow.id
                    ),
                    orderRowModel
                ];
            }

            if (action.result.sketchUpStatus) {
                newState.planOrder.sketchUpStatus = {
                    id: action.result.sketchUpStatus.value,
                    name: action.result.sketchUpStatus.displayName
                };
            }

            if (action.result.roomSketcherStatus) {
                newState.planOrder.roomSketcherStatus = {
                    id: action.result.roomSketcherStatus.value,
                    name: action.result.roomSketcherStatus.displayName
                };
            }

            return newState;

        case types.SEND_TO_PLAN_FIRM_SUCCESS:
            newState = assign({}, state);
            if (newState.planOrder.sketchUpStatus.id !== Status.notOrdered) {
                newState.planOrder.sketchUpStatus = action.result.sketchUpStatus;
            }
            if (newState.planOrder.roomSketcherStatus.id !== Status.notOrdered) {
                newState.planOrder.roomSketcherStatus = action.result.roomSketcherStatus;
            }

            newState.planOrder.planFirmId = action.result.planFirmId;
            newState.planOrder.planEditorId = undefined;
            return newState;
        case types.DELIVER_PLAN_ORDER_SUCCESS:
            newState = assign({}, state);
            if (newState.planOrder.sketchUpStatus.id !== Status.notOrdered) {
                newState.planOrder.sketchUpStatus = action.result.status;
            }
            if (newState.planOrder.roomSketcherStatus.id !== Status.notOrdered) {
                newState.planOrder.roomSketcherStatus = action.result.status;
            }
            newState.planOrder.deliveryMessage = action.result.data.message;
            newState.planOrder.deliveryShouldAppendToEmail = action.result.data.shouldAppendToEmail;
            newState.planOrder.deliveryDate = action.result.data.deliveryDate;
            return newState;
        case types.RETURN_TO_BROKER:
        case types.ADMIN_RETURN_PLAN_ORDER_SUCCESS:
            newState = assign({}, state);
            newState.planOrder.sketchUpStatus = action.result.sketchUpStatus;
            newState.planOrder.roomSketcherStatus = action.result.roomSketcherStatus;
            return newState;
        case types.RETURN_SKETCHUP_PLAN_ORDER_SUCCESS:
            newState = assign({}, state);
            newState.planOrder.sketchUpStatus = action.result.status;
            newState.planOrder.planEditorId = action.result.planEditorId;
            return newState;
        case types.RETURN_ROOMSKETCHER_PLAN_ORDER_SUCCESS:
            newState = assign({}, state);
            newState.planOrder.roomSketcherStatus = action.result.status;
            return newState;
        case types.EMAIL_FILES_PLAN_ORDER_SUCCESS:
            newState = assign({}, state);
            return newState;
        case agentTypes.AGENT_RETURN_PLAN_ORDER_SUCCESS:
            newState = assign({}, state);
            newState.isInProgress = true;
            return newState;
        case types.GENERATE_FILES_PLAN_ORDER_ADMIN_SUCCESS:
            newState = assign({}, state);
            if (action.result) {
                newState.planOrder.delivery = assign({}, action.result);
            }
            return newState;
        case types.APPROVE_PLAN_ORDER_ADMIN_SUCCESS:
            newState = assign({}, state);

            if (newState.planOrder.sketchUpStatus.id !== Status.notOrdered) {
                newState.planOrder.sketchUpStatus = action.result.status;
            }
            if (newState.planOrder.roomSketcherStatus.id !== Status.notOrdered) {
                newState.planOrder.roomSketcherStatus = action.result.status;
            }

            newState.planOrder.delivery.stories = action.result.storyDeliveryFiles;

            return newState;
        case types.ADMIN_ADD_PLAN_ORDER_INTERNAL_EXTERNAL_FILE_SUCCESS:
            newState = assign({}, state);
            newState.planOrder.internalExternalFiles = [
                ...newState.planOrder.internalExternalFiles,
                assign({}, action.result)
            ];

            if (action.result.oldFileId) {
                newState.planOrder.internalExternalFiles = [
                    ...newState.planOrder.internalExternalFiles.filter(
                        (x) => x.id !== action.result.oldFileId
                    )
                ];
            }

            if (newState.planOrder.delivery && newState.planOrder.delivery.internalExternalFiles) {
                newState.planOrder.delivery.internalExternalFiles = [
                    ...newState.planOrder.delivery.internalExternalFiles,
                    assign({}, action.result)
                ];

                if (action.result.oldFileReference) {
                    newState.planOrder.delivery.internalExternalFiles = [
                        ...newState.planOrder.delivery.internalExternalFiles.filter(
                            (x) => x.fileReference !== action.result.oldFileReference
                        )
                    ];
                }
            }

            return newState;
        case types.ADMIN_ADD_PLAN_ORDER_EXTERNAL_DELIVERY_FILE_SUCCESS:
            newState = assign({}, state);
            newState.planOrder.externalDeliveryFiles = [
                ...newState.planOrder.externalDeliveryFiles,
                assign({}, action.result)
            ];

            if (action.result.oldFileId) {
                newState.planOrder.externalDeliveryFiles =
                    newState.planOrder.externalDeliveryFiles.filter(
                        (x) => x.id !== action.result.oldFileId
                    );
            }

            if (newState.planOrder.delivery && newState.planOrder.delivery.externalDeliveryFiles) {
                let newFile = assign({}, action.result);
                newFile.planOrderExternalFileId = newFile.id;
                newState.planOrder.delivery.externalDeliveryFiles = [
                    ...newState.planOrder.delivery.externalDeliveryFiles,
                    newFile
                ];

                if (action.result.oldFileId) {
                    newState.planOrder.delivery.externalDeliveryFiles =
                        newState.planOrder.delivery.externalDeliveryFiles.filter(
                            (x) => x.planOrderExternalFileId !== action.result.oldFileId
                        );
                }
            }

            return newState;
        case types.ADMIN_ADD_PLAN_ORDER_STOREY_EXTERNAL_FILE_SUCCESS:
            newState = assign({}, state);
            let addIndex = newState.planOrder.stories.findIndex(
                (x) => x.id === action.result.planOrderStoreyId
            );

            if (!newState.planOrder.stories[addIndex].externalFiles) {
                newState.planOrder.stories[addIndex].externalFiles = [];
            }

            newState.planOrder.stories[addIndex].externalFiles = [
                ...newState.planOrder.stories[addIndex].externalFiles,
                assign({}, action.result)
            ];

            if (action.result.oldFileInfoId) {
                let deleteIndex = newState.planOrder.stories.findIndex(
                    (x) => x.id === action.result.planOrderStoreyId
                );
                newState.planOrder.stories[deleteIndex].externalFiles = [
                    ...newState.planOrder.stories[deleteIndex].externalFiles.filter(
                        (x) => x.fileInfoId !== action.result.oldFileInfoId
                    )
                ];
            }

            if (newState.planOrder.delivery && newState.planOrder.delivery.internalExternalFiles) {
                newState.planOrder.delivery.internalExternalFiles = [
                    ...newState.planOrder.delivery.internalExternalFiles,
                    assign({}, action.result)
                ];

                if (action.result.oldFileReference) {
                    newState.planOrder.delivery.internalExternalFiles = [
                        ...newState.planOrder.delivery.internalExternalFiles.filter(
                            (x) => x.fileReference !== action.result.oldFileReference
                        )
                    ];
                }
            }

            return newState;
        case types.ADMIN_DELETE_PLAN_ORDER_INTERNAL_EXTERNAL_FILE_SUCCESS:
            newState = assign({}, state);
            newState.planOrder.internalExternalFiles = [
                ...newState.planOrder.internalExternalFiles.filter(
                    (x) => x.fileInfoId !== action.result.fileInfoId
                )
            ];

            if (newState.planOrder.delivery && newState.planOrder.delivery.internalExternalFiles) {
                newState.planOrder.delivery.internalExternalFiles = [
                    ...newState.planOrder.delivery.internalExternalFiles.filter(
                        (x) => x.fileReference !== action.result.fileReference
                    )
                ];
            }

            return newState;
        case types.ADMIN_DELETE_PLAN_ORDER_EXTERNAL_DELIVERY_FILE_SUCCESS:
            newState = assign({}, state);
            newState.planOrder.externalDeliveryFiles = [
                ...newState.planOrder.externalDeliveryFiles.filter(
                    (x) => x.fileInfoId !== action.result.fileInfoId
                )
            ];

            if (newState.planOrder.delivery && newState.planOrder.delivery.externalDeliveryFiles) {
                newState.planOrder.delivery.externalDeliveryFiles = [
                    ...newState.planOrder.delivery.externalDeliveryFiles.filter(
                        (x) => x.fileReference !== action.result.fileReference
                    )
                ];
            }

            return newState;
        case types.ADMIN_DELETE_PLAN_ORDER_STOREY_EXTERNAL_FILE_SUCCESS:
            newState = assign({}, state);
            let deleteIndex = newState.planOrder.stories.findIndex(
                (x) => x.id === action.result.planOrderStoreyId
            );
            newState.planOrder.stories[deleteIndex].externalFiles = [
                ...newState.planOrder.stories[deleteIndex].externalFiles.filter(
                    (x) => x.fileInfoId !== action.result.fileInfoId
                )
            ];

            if (newState.planOrder.delivery && newState.planOrder.delivery.internalExternalFiles) {
                newState.planOrder.delivery.internalExternalFiles = [
                    ...newState.planOrder.delivery.internalExternalFiles.filter(
                        (x) => x.fileReference !== action.result.fileReference
                    )
                ];
            }

            return newState;
        case types.ADD_PLAN_ORDER_STOREY_BLUEPRINT_FILE_SUCCESS:
            newState = assign({}, state);
            let indexStoreyBlueprint = newState.planOrder.stories.findIndex(
                (x) => x.id === action.result.planOrderStoreyId
            );
            let storeyBlueprint = newState.planOrder.stories[indexStoreyBlueprint];
            storeyBlueprint.file = action.result.file;

            if (!storeyBlueprint.files) {
                storeyBlueprint.files = [];
            }

            storeyBlueprint.files.push({
                id: action.result.file.id,
                planOrderStoreyId: storeyBlueprint.id,
                warmStorageReference: action.result.file.fileReference,
                filename: action.result.file.filename,
                revisions: [],
                isBlueprint: true,
                rolename: 'role/administrator'
            });

            return newState;
        case types.ADD_PLAN_ORDER_STOREY_SKETCHUP_2D_FILE_SUCCESS:
            newState = assign({}, state);
            let indexStoreySketchUp2D = newState.planOrder.stories.findIndex(
                (x) => x.id === action.result.planOrderStoreyId
            );
            let storeySketchup2D = newState.planOrder.stories[indexStoreySketchUp2D];
            let last2dId = null;

            if (storeySketchup2D.file2D) {
                last2dId = storeySketchup2D.file2D.id;
            }

            storeySketchup2D.file2D = action.result.file;

            if (!storeySketchup2D.files) {
                storeySketchup2D.files = [];
            }

            storeySketchup2D.files.push({
                id: action.result.file.id,
                planOrderStoreyId: storeySketchup2D.id,
                warmStorageReference: action.result.file.fileReference,
                filename: action.result.file.filename,
                is2D: true,
                revisions: [],
                rolename: 'role/administrator',
                parentId: last2dId
            });

            newState.planOrder.sketchUpStatus = action.result.file.sketchUpStatus;
            newState.planOrder.roomSketcherStatus = action.result.file.roomSketcherStatus;

            return newState;
        case types.ADD_PLAN_ORDER_STOREY_SKETCHUP_3D_FILE_SUCCESS:
            newState = assign({}, state);
            let indexStoreySketchUp3D = newState.planOrder.stories.findIndex(
                (x) => x.id === action.result.planOrderStoreyId
            );

            let storeySketchup3D = newState.planOrder.stories[indexStoreySketchUp3D];
            let last3dId = null;

            if (storeySketchup3D.file3D) {
                last3dId = storeySketchup3D.file3D.id;
            }

            storeySketchup3D.file3D = action.result.file;

            if (!storeySketchup3D.files) {
                storeySketchup3D.files = [];
            }

            storeySketchup3D.files.push({
                id: action.result.file.id,
                planOrderStoreyId: storeySketchup3D.id,
                warmStorageReference: action.result.file.fileReference,
                filename: action.result.file.filename,
                is3D: true,
                revisions: [],
                rolename: 'role/administrator',
                parentId: last3dId
            });

            newState.planOrder.sketchUpStatus = action.result.file.sketchUpStatus;
            newState.planOrder.roomSketcherStatus = action.result.file.roomSketcherStatus;

            return newState;
        case types.ADD_PLAN_ORDER_STOREY_ROOMSKETCHER_2D_FILE_SUCCESS:
            newState = assign({}, state);
            let indexStoreyRoomSketcher2D = newState.planOrder.stories.findIndex(
                (x) => x.id === action.result.planOrderStoreyId
            );

            let storeyRoomSketcher2D = newState.planOrder.stories[indexStoreyRoomSketcher2D];
            let lastRoomSketcher2dId = null;

            storeyRoomSketcher2D.roomSketcherFile2D = action.result.file;

            if (!storeyRoomSketcher2D.files) {
                storeyRoomSketcher2D.files = [];
            }

            storeyRoomSketcher2D.files.push({
                id: action.result.file.id,
                planOrderStoreyId: storeyRoomSketcher2D.id,
                warmStorageReference: action.result.file.fileReference,
                filename: action.result.file.filename,
                is2D: true,
                revisions: [],
                rolename: 'role/administrator',
                parentId: lastRoomSketcher2dId
            });

            newState.planOrder.sketchUpStatus = action.result.file.sketchUpStatus;
            newState.planOrder.roomSketcherStatus = action.result.file.roomSketcherStatus;

            return newState;
        case types.ADD_PLAN_ORDER_STOREY_ROOMSKETCHER_3D_FILE_SUCCESS:
            newState = assign({}, state);
            let indexStoreyRoomSketcher3D = newState.planOrder.stories.findIndex(
                (x) => x.id === action.result.planOrderStoreyId
            );

            let storeyRoomSketcher3D = newState.planOrder.stories[indexStoreyRoomSketcher3D];
            let lastRoomSketcher3dId = null;

            storeyRoomSketcher3D.roomSketcherFile3D = action.result.file;

            if (!storeyRoomSketcher3D.files) {
                storeyRoomSketcher3D.files = [];
            }

            storeyRoomSketcher3D.files.push({
                id: action.result.file.id,
                planOrderStoreyId: storeyRoomSketcher3D.id,
                warmStorageReference: action.result.file.fileReference,
                filename: action.result.file.filename,
                is3D: true,
                revisions: [],
                rolename: 'role/administrator',
                parentId: lastRoomSketcher3dId
            });

            newState.planOrder.sketchUpStatus = action.result.file.sketchUpStatus;
            newState.planOrder.roomSketcherStatus = action.result.file.roomSketcherStatus;

            return newState;
        case types.ADMIN_UPDATE_START_DATE_SUCCESS:
            newState = assign({}, state);
            newState.planOrder.startDate = action.result;
            return newState;
        case types.PLAN_ORDER_TOGGLE_TEMPLATE_GENERATION_SUCCESS:
            newState = assign({}, state);
            newState.planOrder.isTemplateGenerationActive = action.result;
            return newState;
        case types.PLAN_ORDER_ADMIN_GRAB_SUCCESS:
            newState = assign({}, state);
            if (newState.planOrder.sketchUpStatus.id !== Status.notOrdered) {
                newState.planOrder.sketchUpStatus = action.result.status;
            }
            return newState;

        case IMPERSONATE_SUCCESS:
        case UNIMPERSONATE_SUCCESS:
        case LOGOUT_SUCCESS:
        case types.PLAN_ORDER_RESETSTATE:
        case OrderActionTypes.RESET_ORDER_STATES:
            return InitialState.viewPlanOrder;

        case agentTypes.UPLOAD_STOREY_ANNOTATION_FILE_SUCCESS:
            newState = assign({}, state);

            let si = newState.deliveredPlanOrder.deliveryFiles.stories.findIndex(
                (x) => x.id === action.result.storeyId
            );
            let s = newState.deliveredPlanOrder.deliveryFiles.stories[si];

            function map(sf: any): any {
                sf.id = action.result.storeyFileId;
                sf.fileReference = action.result.fileReference;
                sf.thumbnailReference = action.result.thumbnailReference;
                return sf;
            }

            let cont = true;
            if (s.sketchUpPlan2Ds && s.sketchUpPlan2Ds.length > 0) {
                if (s.sketchUpPlan2Ds[0].id === action.result.existingStoreyFileId) {
                    s.sketchUpPlan2Ds = s.sketchUpPlan2Ds.map((sketchUpPlan2D) =>
                        map(sketchUpPlan2D)
                    );
                    cont = false;
                }
            }

            if (cont && s.sketchUpPlan3Ds && s.sketchUpPlan3Ds.length > 0) {
                if (s.sketchUpPlan3Ds[0].id === action.result.existingStoreyFileId) {
                    s.sketchUpPlan3Ds = s.sketchUpPlan3Ds.map((sketchUpPlan3D) =>
                        map(sketchUpPlan3D)
                    );
                    cont = false;
                }
            }

            if (cont && s.roomSketcherPlan2Ds && s.roomSketcherPlan2Ds.length > 0) {
                if (s.roomSketcherPlan2Ds[0].id === action.result.existingStoreyFileId) {
                    s.roomSketcherPlan2Ds = s.roomSketcherPlan2Ds.map((roomSketcherPlan2D) =>
                        map(roomSketcherPlan2D)
                    );
                    cont = false;
                }
            }

            if (cont && s.roomSketcherPlan3Ds && s.roomSketcherPlan3Ds.length > 0) {
                if (s.roomSketcherPlan3Ds[0].id === action.result.existingStoreyFileId) {
                    s.roomSketcherPlan3Ds = s.roomSketcherPlan3Ds.map((roomSketcherPlan3D) =>
                        map(roomSketcherPlan3D)
                    );
                }
            }

            return newState;

        case agentTypes.UPLOAD_ANNOTATION_FILE_SUCCESS:
            newState = assign({}, state);

            newState.deliveredPlanOrder.deliveryFiles.externalAnnotationFiles = [
                ...newState.deliveredPlanOrder.deliveryFiles.externalAnnotationFiles.filter(
                    (x: any) => x.planOrderExternalFileId !== action.result.oldFileId
                )
            ];
            newState.deliveredPlanOrder.deliveryFiles.externalAnnotationFiles.push(action.result);

            return newState;

        case types.HIDE_DELIVERY_FAILURE:
            newState = assign({}, state);

            newState.planOrder.sketchUpStatus = action.result.sketchUpStatus;
            newState.planOrder.roomSketcherStatus = action.result.roomSketcherStatus;

            return newState;

        case types.ROOMSKETCHER_STATUS_SET_SUCCESSFULLY:
            newState = assign({}, state);
            newState.planOrder.roomSketcherStatus = action.result.roomSketcherStatus;
            return newState;

        case types.SKETCHUP_STATUS_SET_SUCCESSFULLY:
            newState = assign({}, state);
            newState.planOrder.sketchUpStatus = action.result;
            return newState;

        case types.ADMIN_DELETE_DELIVERY_FILE_SUCCESS:
            newState = assign({}, state);

            newState.planOrder.delivery.stories.forEach((s) => {
                let su2Ds = s.sketchUpPlan2Ds.filter((x: any) => x.fileReference !== action.result);
                s.sketchUpPlan2Ds = su2Ds;

                let su3Ds = s.sketchUpPlan3Ds.filter((x: any) => x.fileReference !== action.result);
                s.sketchUpPlan3Ds = su3Ds;

                let rs2Ds = s.roomSketcherPlan2Ds.filter(
                    (x: any) => x.fileReference !== action.result
                );
                s.roomSketcherPlan2Ds = rs2Ds;

                let rs3Ds = s.roomSketcherPlan3Ds.filter(
                    (x: any) => x.fileReference !== action.result
                );
                s.roomSketcherPlan3Ds = rs3Ds;
            });

            let edf = newState.planOrder.externalDeliveryFiles.filter(
                (x: any) => x.fileReference !== action.result
            );
            newState.planOrder.externalDeliveryFiles = edf;

            let dedf = newState.planOrder.delivery.externalDeliveryFiles.filter(
                (y: any) => y.fileReference !== action.result
            );
            newState.planOrder.delivery.externalDeliveryFiles = dedf;

            return newState;

        case types.INACTIVATE_EXTERNAL_FILE_SUCCESS:
            newState = assign({}, state);
            if (
                newState.planOrder &&
                newState.planOrder.delivery &&
                newState.planOrder.delivery.externalAnnotationFiles
            ) {
                newState.planOrder.delivery.externalAnnotationFiles =
                    newState.planOrder.delivery.externalAnnotationFiles.filter(
                        (f) => f.planOrderExternalFileId !== action.result
                    );
            }
            if (
                newState.deliveredPlanOrder &&
                newState.deliveredPlanOrder.deliveryFiles &&
                newState.deliveredPlanOrder.deliveryFiles.externalAnnotationFiles
            ) {
                newState.deliveredPlanOrder.deliveryFiles.externalAnnotationFiles =
                    newState.deliveredPlanOrder.deliveryFiles.externalAnnotationFiles.filter(
                        (f) => f.planOrderExternalFileId !== action.result
                    );
            }
            return newState;
        case types.ADMIN_RESET_SCHEDULED_PLAN_ORDER_DELIVERY_SUCCESS:
            newState = assign({}, state);
            newState.planOrder.sketchUpStatus.id = action.result.sketchUpStatus.id;
            newState.planOrder.roomSketcherStatus.id = action.result.roomSketcherStatus.id;
            newState.planOrder.sketchUpStatus.name = action.result.sketchUpStatus.name;
            newState.planOrder.deliveryDate = action.result.deliveryDate;
            return newState;
        case types.SET_PLAN_ORDER_SUCCESS:
            return {
                ...state,
                planOrder: action.result
            };
        case types.RETURN_CUBI_CASA_ORDER_SUCCESS:
            newState = assign({},state);
            newState.planOrder.cubiCasaOrderStatus = action.result;
            return newState;
        default:
            return state;
    }
}
